<template lang="pug">
.state-container
	h2 
		span(v-if="currentView !== 'all'") Locations By State 
		span.state-container__pipe(v-if="currentView !== 'all'") &nbsp;|&nbsp; 
		| {{ stateNames[stateName] }}
	.state-container__list
		LocationBox(v-for="(location, index) in locationArray", :key="location.Id", :location="location")
</template>

<script>
import { mapGetters } from "vuex";

import LocationBox from "./LocationBox";

export default {
	name: "StateContainer",
	components: {
		LocationBox
	},
	props: {
		locationArray: Array,
		stateName: String
	},
	computed: {
		...mapGetters([
			"currentView",
			"stateNames",
		]),
	}
}
</script>

<style lang="scss" scoped>
.state-container {
	margin-bottom: 3.5rem;
	&__list {
		display: flex;
		flex-wrap: wrap;
		gap: 1.5rem;
	}
	h2 {
		& > span {
			font-weight: 400;
		}
	}
	&__pipe {
		display: none;
		@include mq(sm) {
			display: inline;
		}
	}
}
</style>